import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Users, Package, Key } from 'lucide-react';
import toast from 'react-hot-toast';
import { adminStatsAPI } from '../utils/api';
import { useAuth } from '../context/AuthContext';
import StatCard from '../components/StatCard';

const Home = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user } = useAuth();
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await adminStatsAPI.get();
        setStats(response.data.data);
      } catch (error) {
        toast.error(t('errors.serverError'));
      } finally {
        setLoading(false);
      }
    };
    fetchStats();
  }, [t]);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">
          {t('home.welcome', { name: user?.fullName || user?.username || '' })}
        </h1>
        <p className="text-gray-500 text-sm mt-1">{t('home.subtitle')}</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <StatCard
          icon={Users}
          title={t('home.cards.users')}
          value={stats?.users ?? 0}
          subtitle={t('home.cards.total')}
          color="blue"
          loading={loading}
          onClick={() => navigate('/users')}
        />
        <StatCard
          icon={Package}
          title={t('home.cards.plugins')}
          value={stats?.plugins ?? 0}
          subtitle={t('home.cards.total')}
          color="green"
          loading={loading}
          onClick={() => navigate('/plugins')}
        />
        <StatCard
          icon={Key}
          title={t('home.cards.licences')}
          value={stats?.licenses ?? 0}
          subtitle={t('home.cards.total')}
          color="purple"
          loading={loading}
          onClick={() => navigate('/licences')}
        />
      </div>
    </div>
  );
};

export default Home;